if (typeof window.open === "function") {
  const openOld = window.open;
  const openNewWindow = function(a, b, c, d) {
    const dpr = window.devicePixelRatio || 1;
    let border = (dpr - 1) * 2 + 1;
    if (window.navigator.userAgent.match(/Mac/)) {
      border = 0;
    }
    // const width = window.screen.availWidth - 10 * border;
    // const height = window.screen.availHeight - 50 * border;
    const width = (window.outerWidth || window.screen.availWidth) - 10 * border;
    const height =
      (window.outerHeight || window.screen.availHeight) - 50 * border;
    const left = window.screenLeft || 0;
    const top = window.screenTop || 0;
    return openOld(
      a,
      b,
      `alwaysRaised=yes,width=${width},height=${height},top=${top},left=${left},directories=no,status=no,toolbar=no,location=no,menubar=no,scrollbars=yes,resizable=yes`
    );
  };
  const openNewTab = function(a, b, c, d) {
    return openOld(a, b || "_blank");
  };
  const openReWirte = function(a, b, c, d) {
    if (c && c.match(/ecologysetting=no/)) {
      return openOld(a, b, c, d);
    }
    if (window.localStorage.getItem("ec_open_rewrite") === "0") {
      return openNewWindow(a, b, c, d);
    }
    return openNewTab(a, b, c, d);
  };
  window.open = openReWirte;
  window.document.addEventListener("keydown", e => {
    const ev = e || window.event;
    if (ev.keyCode === 16) {
      // shift
      window.open = openNewWindow;
    }
    if (window.navigator.userAgent.match(/Mac/)) {
      if (ev.keyCode === 91) {
        // command
        window.open = openNewTab;
      }
    } else if (ev.keyCode === 17) {
      // ctrl
      window.open = openNewTab;
      // if (window.navigator.userAgent.match(/Chrome/)) {
      //   window.open = openOld;
      // } else {
      //   window.open = openNewTab;
      // }
    }
  });
  window.document.addEventListener("keyup", e => {
    const ev = e || window.event;
    if (
      ev.keyCode === 16 ||
      ev.keyCode === 17 ||
      (window.navigator.userAgent.match(/Mac/) && ev.keyCode === 91)
    ) {
      window.open = openReWirte;
    }
  });
  window.addEventListener("blur", () => {
    window.open = openReWirte;
  });
}



// WEBPACK FOOTER //
// ./ecology9/wea-tools/open.js